﻿/* eslint-disable prettier/prettier */
import $ = require('jquery');
import { initCookieConsent } from './cookie-consent';
import { initContactForm } from './contact-form';
import 'slick-carousel';

$(document).ready(() => {
  initContactForm();
  initCookieConsent();

  //SLICK SLIDER
  $('.referenceSection__logoSliderContainer').slick({
    arrows: true,
    nextArrow:
      "<img class='slick-next' alt='slick-next-image' src='/images/referenceArrow.png'>",
    accessibility: false,
    slidesToShow: 4,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  function setHeight(el: HTMLElement, val: any) {
    if (typeof val === 'function') val = val();
    if (typeof val === 'string') el.style.height = val;
  }

  const elements = document.querySelectorAll('.additionalDataSection .block');
  let highestBox = 0;
  Array.prototype.forEach.call(elements, function (el: HTMLElement, i: number) {
    if (el.offsetHeight > highestBox) {
      highestBox = el.offsetHeight;
    }
  });
  if (window.innerWidth > 940) {
    setHeight(
      document.querySelector('.additionalDataSection .block'),
      highestBox
    );
  }

  const menuButton = document.querySelector('.menuButton');
  const mainNav = document.querySelector('.main-navigation');
  const siteHeader = document.querySelector('.site-header');

  menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('open');
    mainNav.classList.toggle('open');
  });

  window.addEventListener('scroll', function (e) {
    checkIfScrolled();
  });

  function checkIfScrolled() {
    if (window.innerWidth > 940) {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 200) {
        siteHeader.classList.add('scrolled');
      } else {
        siteHeader.classList.remove('scrolled');
      }
    }
  }
  checkIfScrolled();

  const megaMenuLinks = document.querySelectorAll('.megaMenu a');

  megaMenuLinks.forEach(function (menuLink: HTMLElement) {
    menuLink.addEventListener('mouseover', (e) => {

      document.querySelectorAll('.megaMenu__image').forEach(function (item) {
        item.classList.remove('show');
      });
    });
  });

  const dropdowns = document.querySelectorAll('.dropDown');

  dropdowns.forEach(function (dropdown: HTMLElement) {
    const megaMenu = dropdown.parentElement.nextElementSibling;

    dropdown.addEventListener('click', (e) => {
      e.preventDefault();

      const showItems = document.querySelectorAll('.mega-show');
      const target = e.target as HTMLLinkElement;
      let activeId = target.parentElement.id;
      if(activeId.length == 0){
        activeId = target.parentElement.parentElement.id;
      }

      const mainLinks = document.querySelectorAll(".main-link");
      for (let i = 0; i < mainLinks.length; i++) {
        if(mainLinks[i].id !== activeId){

          const dropdownItem = mainLinks[i].children[0] as HTMLLIElement;
          if(dropdownItem != undefined){
            dropdownItem.classList.remove("show");
          }
        }
      }
      for (let i = 0; i < showItems.length; i++) {

        if (!showItems[i].classList.contains(activeId)) {
          showItems[i].classList.remove('show');
          showItems[i].classList.remove('mega-show');
        }
      }
      megaMenu.classList.toggle('mega-show');
      megaMenu.classList.toggle('show');
      dropdown.classList.toggle('show');
    });
  });

  const langSwitcher = document.querySelector('.langSwitcher');
  const langSwitcherMenu = document.querySelector('.langSwitcher__menu');

  // langSwitcher can be null if there is no more than one published language on the site
  if (langSwitcher != null) {
    langSwitcher.addEventListener('click', (e) => {
      langSwitcherMenu.classList.toggle('show');
    });
  }
  const countryItems = document.querySelectorAll(".country-item");
  if(countryItems != null){
    for(let i = 0; i < countryItems.length; i ++){
      countryItems[i].addEventListener('click', () => {
        countryItems[i].parentElement.classList.toggle("open");
      });
    }
  }
});